module.exports = __webpack_public_path__ + "static/media/44.7b9090a4.jpg";